// extracted by mini-css-extract-plugin
export default {"advantages":"AdvantagesGens_advantages__AopDR","title":"AdvantagesGens_title__kw4VB","grid":"AdvantagesGens_grid__4yhBx"};